import { useLang } from "./LanguageContext";

const itemsByLang = {
  en: ["Handcrafted", "Tableside", "Private Events", "Culinary Theatre", "Made to Order", "Artigianale"],
  it: ["Fatto a mano", "Al tavolo", "Eventi privati", "Teatro Culinario", "Su ordinazione", "Artigianale"],
  ru: ["Ручная работа", "У стола", "Частные события", "Кейтеринг на заказ", "По заказу", "Artigianale"],
  es: ["Hecho a mano", "Junto a la mesa", "Eventos privados", "Teatro Culinario", "Al momento", "Artigianale"],
};

export const Marquee = () => {
  const { lang } = useLang();
  const items = itemsByLang[lang];
  const loop = [...items, ...items];
  return (
    <section className="py-8 md:py-12 border-y border-ink/10 overflow-hidden" data-testid="marquee-section">
      <div className="marquee-track">
        {loop.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-4xl md:text-6xl text-ink/25 px-8">{t}</span>
            <span className="text-terracotta text-2xl md:text-4xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
